/* v8 ignore start */
/**
 * Standardized error codes for the mainio-agent system.
 * These codes are used consistently across all components.
 */
export const ERROR_CODES = {
    // Connection Errors
    CONNECTION_ERROR: 'CONNECTION_ERROR',
    CONNECTION_TIMEOUT: 'CONNECTION_TIMEOUT',
    CONNECTION_CLOSED: 'CONNECTION_CLOSED',
    // Server Errors
    SERVER_ERROR: 'SERVER_ERROR',
    RATE_LIMIT: 'RATE_LIMIT',
    SERVICE_UNAVAILABLE: 'SERVICE_UNAVAILABLE',
    BAD_GATEWAY: 'BAD_GATEWAY',
    GATEWAY_TIMEOUT: 'GATEWAY_TIMEOUT',
    // Client Errors
    INVALID_REQUEST: 'INVALID_REQUEST',
    AUTHENTICATION_ERROR: 'AUTHENTICATION_ERROR',
    AUTHORIZATION_ERROR: 'AUTHORIZATION_ERROR',
    UNAUTHORIZED: 'UNAUTHORIZED',
    FORBIDDEN: 'FORBIDDEN',
    NOT_FOUND: 'NOT_FOUND',
    REQUEST_TIMEOUT: 'REQUEST_TIMEOUT',
    REQUEST_FAILED: 'REQUEST_FAILED',
    // External Service Errors
    OPENAI_ERROR: 'OPENAI_ERROR',
    EXTERNAL_SERVICE_ERROR: 'EXTERNAL_SERVICE_ERROR',
    // Functional Errors
    INVALID_RESPONSE: 'INVALID_RESPONSE',
    STREAM_ERROR: 'STREAM_ERROR',
    PROTOCOL_ERROR: 'PROTOCOL_ERROR',
    // State Errors
    STATE_ERROR: 'STATE_ERROR',
    INVALID_STATE: 'INVALID_STATE',
    INVALID_CONFIG: 'INVALID_CONFIG',
    // Generic Error
    UNKNOWN_ERROR: 'UNKNOWN_ERROR'
};
/**
 * Mapping HTTP status codes to standardized error codes
 *
 * @param {number} status - The HTTP status code
 * @returns {string} The standardized error code
 */
export const mapHttpStatusToErrorCode = (status) => {
    switch (status) {
        case 400:
            return ERROR_CODES.INVALID_REQUEST;
        case 401:
            return ERROR_CODES.UNAUTHORIZED;
        case 403:
            return ERROR_CODES.FORBIDDEN;
        case 404:
            return ERROR_CODES.NOT_FOUND;
        case 408:
            return ERROR_CODES.REQUEST_TIMEOUT;
        case 429:
            return ERROR_CODES.RATE_LIMIT;
        case 500:
            return ERROR_CODES.SERVER_ERROR;
        case 502:
            return ERROR_CODES.BAD_GATEWAY;
        case 503:
            return ERROR_CODES.SERVICE_UNAVAILABLE;
        case 504:
            return ERROR_CODES.GATEWAY_TIMEOUT;
        default:
            return status >= 500 ? ERROR_CODES.SERVER_ERROR : ERROR_CODES.UNKNOWN_ERROR;
    }
};
//# sourceMappingURL=errorCodes.js.map